<ng-template #selectAll let-selectOptions="selectOptions">
  <mat-option (click)="toggleSelectAll(selectOptions)">
    <mat-pseudo-checkbox
      class="mat-option-pseudo-checkbox"
      [state]="getSelectAllState(selectOptions)"
    >
    </mat-pseudo-checkbox>
    {{ props['selectAllOption'] }}
  </mat-option>
</ng-template>
<mat-select
  #select
  [class.has-modal]="props['modal']"
  [id]="id"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [placeholder]="props['placeholder'] ?? ''"
  [tabIndex]="props.tabindex"
  [required]="required"
  [compareWith]="props['compareWith']"
  [multiple]="props['multiple']"
  (selectionChange)="change($event)"
  [errorStateMatcher]="errorStateMatcher"
  [aria-label]="_getAriaLabel()"
  [aria-labelledby]="_getAriaLabelledby()"
  [disableOptionCentering]="props['disableOptionCentering']"
  [typeaheadDebounceInterval]="props['typeaheadDebounceInterval']"
>
  @if (props.options | formlySelectOptions: field | async; as selectOptions) {
    <!--    <mat-select-trigger>{{select.value}}</mat-select-trigger>-->

    @if (!props['disableFilter']) {
      <mat-option>
        <ngx-mat-select-search
          [formControl]="searchControl"
          placeholderLabel="Search"
          noEntriesFoundLabel="No results"
        ></ngx-mat-select-search>
      </mat-option>
    }

    @if (props['multiple'] && props['selectAllOption']) {
      <ng-container
        [ngTemplateOutlet]="selectAll"
        [ngTemplateOutletContext]="{ selectOptions: selectOptions }"
      >
      </ng-container>
    }
    @for (item of filteredOptions; track item.group || item.value) {
      @if (item.group) {
        <mat-optgroup [label]="item.label">
          @for (child of item.group; track child.value) {
            <mat-option [value]="child.value" [disabled]="child.disabled">
              {{ child.label }}
            </mat-option>
          }
        </mat-optgroup>
      }
      @if (!item.group) {
        <mat-option [value]="item.value" [disabled]="item.disabled">{{
          item.label
        }}</mat-option>
      }
    }
  }
</mat-select>

@if (props['modal']) {
  <button
    matSuffix
    nbButton
    status="info"
    (click)="addModal($event)"
    size="small"
    type="button"
    class="me-1 float-end"
  >
    Add
  </button>
}
